// extracted by mini-css-extract-plugin
export default {"errorMsg":"A4WY6__errorMsg","errorMsgReason":"GQYtk__errorMsgReason","msTeamsConnecting":"cmKQf__msTeamsConnecting","timer":"lnxMs__timer"};